<template>
  <v-navigation-drawer
    v-model="navigationDrawerVisible"
    temporary
    app
  >
    <template #prepend>
      <v-row
        class="pyellow"
        dense
      >
        <v-col cols="12">
          <v-img
            src="/img/logo.jpg"
            height="70"
            contain
          />
        </v-col>
      </v-row>
      <v-list
        tile
        dense
        color="grey darken-2"
        dark
        style="border-radius:0"
      >
        <v-list-item>
          <v-list-item-avatar color="indigo">
            <v-icon dark>
              mdi-account-circle
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content v-if="user">
            <v-list-item-title>{{ user.Fullname }}</v-list-item-title>
            <v-list-item-subtitle>{{ user.Username }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
    </template>

    <v-list
      nav
      dense
    >
      <template v-for="(item, i) in items">
        <v-row
          v-if="item.heading"
          :key="`heading-${i}`"
          align="center"
        >
          <v-col
            cols="6"
            class="text-left py-0 my-0"
          >
            <v-subheader>
              {{ item.heading }}
            </v-subheader>
          </v-col>
          <v-col
            cols="6"
            class="text-right py-0 my-0"
          >
            <v-btn
              v-if="item.text && item.route"
              :to="item.route"
              :exact="item.route.exact"
              small
              text
            >
              {{ item.text }}
            </v-btn>
          </v-col>
        </v-row>

        <v-divider
          v-else-if="item.divider"
          :key="`divider-${i}`"
          class="my-2"
        />

        <v-list-group
          v-else-if="item.children"
          :key="i"
          v-model="item.model"
          no-action
        >
          <template #activator>
            <v-list-item
              class="pl-0"
              style="height: 40px;"
            >
              <v-list-item-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>
                  <v-subheader class="pl-0">
                    {{ item.text }}
                  </v-subheader>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item
            v-for="(child, c) in item.children"
            :key="`child-${i}-${c}`"
            :to="child.route"
            :exact="child.route.exact"
            class="pl-2"
          >
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>
                {{ child.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item
          v-else
          :key="`item-${i}`"
          :to="item.route"
          :exact="item.route.exact"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>

    <template #append>
      <v-divider />
      <v-btn
        color="pred"
        dark
        block
        large
        tile
        @click="logout"
      >
        <v-icon left>
          mdi-logout
        </v-icon>
        {{ $t('Auth.Logout.Title') }}
      </v-btn>
    </template>
  </v-navigation-drawer>
</template>

<script>
import Auth from '../../mixins/auth'

export default {
  name      : 'AppNavigationDrawer',
  components: {},
  directives: {},
  mixins    : [Auth],
  props     : {
    navigationDrawer: {
      type    : Boolean,
      required: true
    },
    items: {
      type    : Array,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    navigationDrawerVisible: {
      get () {
        return this.navigationDrawer
      },
      set (val) {
        this.$emit('update:navigationDrawer', val)
      }
    }
  },
  watch: {},
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  methods: {}
}
</script>

<style scoped>

</style>
